import { Button, Popconfirm, Tag, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from '@nic/commons'
import { useScopeInfo } from '../../Hooks/useScopeInfo'
import { AssignmentRequestActionsProps } from '../ButtonsAssignmentRequestActions'
import { useReleaseAssignedRequest } from './useReleaseAssignedRequest'
import { printAssignmentRequestActionError } from './printAssignmentRequestActionError'
import { UserDeleteOutlined } from '@ant-design/icons'
import { stringify } from 'qs'
import { useRouter } from '../../Hooks/useRouter'

export function ButtonReleaseAssignedRequest({
                                               requestId,
                                               onSuccess,
                                               disableReleaseButton,
                                             }: AssignmentRequestActionsProps) {
  const t = useTranslation()
  const { scope } = useScopeInfo()
  const { loading, error, handleReleaseAssignedRequest } = useReleaseAssignedRequest()
  const router = useRouter()

  if (error) {
    return <Tag color={'red'}>{printAssignmentRequestActionError({ error })}</Tag>
  }


  const handleOnClick = () => {
    handleReleaseAssignedRequest(requestId, scope).then(() => {
      if (onSuccess) {
        onSuccess && onSuccess()
      } else {
        router.history.push(
          router.pathname + '?' + stringify({ ...router.query, reload: new Date() }),
        )
      }
    })
  }

  const releaseButton = (
    <Button
      data-cy="releaseButton"
      icon={<UserDeleteOutlined />}
      type='link' disabled={disableReleaseButton}
      loading={loading}
    />)

  return disableReleaseButton ? releaseButton : (
    <Tooltip title={t('assignmentRequests.action.releaseAssignedRequest')}>
      <Popconfirm
        title={t('assignmentRequests.message.releaseAssignedRequest')}
        onConfirm={handleOnClick}
        okText={t('yes')}
        cancelText={t('no')}
      >
        {releaseButton}
      </Popconfirm>
    </Tooltip>
  )
}
